import { useEffect, useState } from "react";
import axios from "axios";

/**
 * Custom hook for fetching sessions information.
 * @returns An object containing the fetched data, loading state, and a function to fetch sessions information.
 */
const useInsertProject = () => {
    const [data, setData] = useState<any>({});
    const [loading, setLoading] = useState(false);

    const API_URL = process.env.REACT_APP_INSERT_PROJECT || ""
    const api_key = process.env.REACT_APP_PROJECT_API_KEY || ""
    /** 
     * Fetches sessions information using the provided request object.
     * @param requestObject - The request object containing the necessary parameters for fetching sessions information.
     */
    const insertProject = async (requestObject: any) => {
        try {
            setLoading(true);
            const responseFetch = await fetch(API_URL, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "x-api-key": api_key
                },
                body: JSON.stringify(requestObject),
              });

        const contentType = responseFetch.headers.get("Content-Type");
        let response;
        if (contentType && contentType.includes("application/json")) {
            response = await responseFetch.json();
        } else {
            response = await responseFetch.text(); // Handle non-JSON responses
            console.warn("Response is not JSON:", response);
        }
       
            setData(response);
        } catch (error) {
            setData(null);
        console.error("Error in insertProject:", error);
        } finally {
            setLoading(false);
        }
};
    return { data, loading, insertProject };
};

export default useInsertProject;